import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChildFn,
  CanActivateFn,
  Router,
  RouterStateSnapshot
} from '@angular/router';

import { AuthService } from '@core/services/auth/auth';
import { DeepLinkService } from '@core/services/deep-link/deep-link';

export const authGuard: CanActivateFn = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService = inject(AuthService);
  const deepLinkService = inject(DeepLinkService);
  const router = inject(Router);
  await authService.awaitReady();
  if (authService.isAuthenticated()) {
    return true;
  } else {
    deepLinkService.setRedirectUrl(state.url);
    return router.createUrlTree(['auth', 'login']);
  }
};

export const authChildGuard: CanActivateChildFn = async (
  childRoute: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const authService = inject(AuthService);
  const deepLinkService = inject(DeepLinkService);
  const router = inject(Router);
  await authService.awaitReady();
  if (authService.isAuthenticated()) {
    return true;
  } else {
    deepLinkService.setRedirectUrl(state.url);
    return router.createUrlTree(['auth', 'login']);
  }
};

export const loggedInGuard: CanActivateFn = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  await authService.awaitReady();
  return !authService.isAuthenticated() || router.createUrlTree(['home']);
};
